/**
 * @flow
 * @relayHash a1c27db6b7cb639c425a6b982f81178b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteBatchReviewAssetsInput = {|
  ids: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type BatchDeleteReviewAssetMutationVariables = {|
  input: DeleteBatchReviewAssetsInput
|};
export type BatchDeleteReviewAssetMutationResponse = {|
  +deleteBatchReviewAssets: ?{|
    +isDeleted: ?boolean
  |}
|};
export type BatchDeleteReviewAssetMutation = {|
  variables: BatchDeleteReviewAssetMutationVariables,
  response: BatchDeleteReviewAssetMutationResponse,
|};
*/


/*
mutation BatchDeleteReviewAssetMutation(
  $input: DeleteBatchReviewAssetsInput!
) {
  deleteBatchReviewAssets(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteBatchReviewAssetsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteBatchReviewAssets",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteBatchReviewAssetsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BatchDeleteReviewAssetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "BatchDeleteReviewAssetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "BatchDeleteReviewAssetMutation",
    "id": null,
    "text": "mutation BatchDeleteReviewAssetMutation(\n  $input: DeleteBatchReviewAssetsInput!\n) {\n  deleteBatchReviewAssets(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '26371d540602435e4389fe2000eb1d3b';
module.exports = node;
